module.exports = __webpack_public_path__ + "static/img/changguan-3.cb3b4597.png";